import { render } from "./ManageCards.vue?vue&type=template&id=1651889c"
import script from "./ManageCards.vue?vue&type=script&lang=js"
export * from "./ManageCards.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__